// Small wrapper around localStorage so we:
//  1. don't crash when localStorage is unavailable (SSR, private mode, quota exceeded)
//  2. surface issues in dev via console.warn instead of silently swallowing them

const inDev = typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production';

export function safeGet(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null) return fallback;
    return JSON.parse(raw);
  } catch (err) {
    if (inDev) console.warn(`[HGS] localStorage read failed for ${key}:`, err?.message || err);
    return fallback;
  }
}

export function safeSet(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    if (inDev) console.warn(`[HGS] localStorage write failed for ${key}:`, err?.message || err);
  }
}

export function safeRemove(key) {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    if (inDev) console.warn(`[HGS] localStorage remove failed for ${key}:`, err?.message || err);
  }
}
